import { getPreferenceFromCache } from "src/services/PreferenceStore";
import { OneViewFilter, stringToView } from "../toLocalStorage";
import { stripViewFilterPrefix } from "./stripViewFilterPrefix";

type GetAllOption = {
    gridKey: string;
};
export const getViews = (options: GetAllOption): OneViewFilter[] => {
    const preferenceKey = stripViewFilterPrefix(options.gridKey);
    const customOrder = getPreferenceFromCache<string[]>("grid.views.order", preferenceKey) ?? undefined;

    const cached = getPreferenceFromCache<Record<string, string>>("grid.views", preferenceKey);
    if (cached !== null) {
        return stringToView(JSON.stringify(cached), customOrder);
    }

    // Fallback: read from legacy localStorage key (uses original key with prefix)
    const filtersAsString = localStorage.getItem(options.gridKey);
    if (filtersAsString === null) return [];

    return stringToView(filtersAsString, customOrder);
};
